import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3;
var _excluded = ["as", "href", "className", "css", "icon", "arrow", "withoutBorders", "isWhite", "isDark", "htmlType", "white", "darkMode", "xs", "customIcon", "customSize", "customColor", "children"],
  _excluded2 = ["component"],
  _excluded3 = ["htmlProps"],
  _excluded4 = ["htmlProps"],
  _excluded5 = ["htmlProps"],
  _excluded6 = ["htmlProps"];
import { forwardRef, useMemo } from 'react';
import cn from 'classnames';
import { css } from 'styled-components';
import ArrowIosLeft from '@crehana/icons/outline/ArrowIosLeft';
import ArrowIosRight from '@crehana/icons/outline/ArrowIosRight';
import ArrowLeft from '@crehana/icons/outline/ArrowLeft';
import ArrowRight from '@crehana/icons/outline/ArrowRight';
import getDefaultIconPropValues from "../../helpers/getDefaultIconPropValues";
import parseClassnames from "../../helpers/parseClassnames";
import { ICON_BUTTON_TYPES, ICON_BUTTON_XS_TYPES } from "./classnames";
import { jsx as _jsx } from "react/jsx-runtime";
var IconButton = function IconButton(_ref, ref) {
  var as = _ref.as,
    href = _ref.href,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    cssProp = _ref.css,
    iconProp = _ref.icon,
    arrow = _ref.arrow,
    withoutBorders = _ref.withoutBorders,
    isWhite = _ref.isWhite,
    isDark = _ref.isDark,
    htmlType = _ref.htmlType,
    white = _ref.white,
    darkMode = _ref.darkMode,
    xs = _ref.xs,
    customIcon = _ref.customIcon,
    customSize = _ref.customSize,
    customColor = _ref.customColor,
    children = _ref.children,
    iconButtonProps = _objectWithoutProperties(_ref, _excluded);
  var defaultIconSize = customSize || (withoutBorders || xs ? 32 : 24);
  var DefaultIcon = useMemo(function () {
    if (withoutBorders || xs) {
      if (arrow === 'left') {
        return ArrowIosLeft;
      }
      if (arrow === 'right') {
        return ArrowIosRight;
      }
    }
    if (arrow === 'left') {
      return ArrowLeft;
    }
    if (arrow === 'right') {
      return ArrowRight;
    }
    return customIcon;
  }, [arrow, customIcon, withoutBorders, xs]);
  var _getDefaultIconPropVa = getDefaultIconPropValues(iconProp, defaultIconSize),
    Icon = _getDefaultIconPropVa.component,
    icon = _objectWithoutProperties(_getDefaultIconPropVa, _excluded2);
  var buttonType = isDark || darkMode ? 'dark' : 'default';
  if (isWhite || white) {
    buttonType = 'white';
  }
  var wrapperClassName = parseClassnames(className, withoutBorders || xs ? ICON_BUTTON_XS_TYPES[buttonType] : ICON_BUTTON_TYPES[buttonType]);
  var wrapperCss = /*#__PURE__*/css(["\n    transition: ", ";\n    & path {\n      transition: ", ";\n    }\n    ", "\n  "], function (_ref2) {
    var theme = _ref2.theme;
    return theme.transition('border');
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.transition('fill');
  }, cssProp);
  var renderChildren = function renderChildren() {
    if (DefaultIcon) {
      return /*#__PURE__*/_jsx(DefaultIcon, {
        size: defaultIconSize,
        color: customColor,
        ignoreColor: !customColor,
        className: !customColor ? 'fill-current' : undefined
      });
    }
    if (Icon) {
      return /*#__PURE__*/_jsx(Icon, {
        size: icon.size,
        className: cn({
          'fill-current': icon.hasFill,
          'stroke-current': icon.hasStroke
        }, 'flex-shrink-0'),
        ignoreColor: true
      });
    }
    return children;
  };
  if (as === 'a' || href) {
    var _ref4 = iconButtonProps,
      _htmlProps = _ref4.htmlProps,
      aProps = _objectWithoutProperties(_ref4, _excluded3);
    return /*#__PURE__*/_jsx(_StyledA, _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      href: href,
      className: wrapperClassName
    }, _htmlProps), aProps), {}, {
      $_css: wrapperCss,
      children: renderChildren()
    }));
  }
  if (as === 'label') {
    var _ref5 = iconButtonProps,
      _htmlProps2 = _ref5.htmlProps,
      labelProps = _objectWithoutProperties(_ref5, _excluded4);
    return /*#__PURE__*/_jsx(_StyledLabel, _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      className: wrapperClassName
    }, _htmlProps2), labelProps), {}, {
      $_css2: wrapperCss,
      children: renderChildren()
    }));
  }
  if (as === 'span') {
    var _ref6 = iconButtonProps,
      _htmlProps3 = _ref6.htmlProps,
      spanProps = _objectWithoutProperties(_ref6, _excluded5);
    return /*#__PURE__*/_jsx(_StyledSpan, _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      className: wrapperClassName
    }, _htmlProps3), spanProps), {}, {
      $_css3: wrapperCss,
      children: renderChildren()
    }));
  }
  var _ref7 = iconButtonProps,
    htmlProps = _ref7.htmlProps,
    buttonProps = _objectWithoutProperties(_ref7, _excluded6);
  return /*#__PURE__*/_jsx(_StyledButton, _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    type: "button",
    className: wrapperClassName
  }, htmlProps), buttonProps), {}, {
    $_css4: wrapperCss,
    children: renderChildren()
  }));
};
export default /*#__PURE__*/forwardRef(IconButton);
var _StyledA = /*#__PURE__*/_styled("a")(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledLabel = /*#__PURE__*/_styled2("label")(_templateObject2 || (_templateObject2 = /*#__PURE__*/_taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledSpan = /*#__PURE__*/_styled3("span")(_templateObject3 || (_templateObject3 = /*#__PURE__*/_taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledButton = /*#__PURE__*/_styled4("button").withConfig({
  componentId: "sc-pcoje4-0"
})(["", ""], function (p) {
  return p.$_css4;
});